import React from 'react'
import Loader from 'view/component/loader'
// import logo from 'img/fm logo.svg'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { navRoutes, mpNavRoutes } from 'constant/nav-routes'
// import Navbar from 'react-bootstrap/Navbar'
import { Routes, Route, redirect } from 'react-router-dom'
import Home from 'view/page/home'
import Navbar from 'view/component/navbar'
import { Layout } from 'antd'
import Footer from 'view/component/footer'
import * as Components from './lazy-components'

const { Content } = Layout

const LoggedInRoutes = ({ user }) => {
  return (
    user
    ? <>
      <Navbar />
      <Footer plcp={true} />
      {getLayout(user)}
    </>
    : <Loader />
  )
}

const getLayout = (user) => (
  <Layout className='bg-white'>
    <Content>
      <Routes>
        {navRoutes.map(({ component, exact, href }, index) => {
          return (
            <Route
              element={component}
              exact={exact}
              key={index}
              path={href}
            />
          )
        })}
        <Route
          element={<Home />}
          path='/'
        />
      </Routes>
    </Content>
  </Layout>)

LoggedInRoutes.propTypes = {
}

const mapStateToProps = (state) => ({
  user: state.auth.user
})

export default connect(mapStateToProps, null)(LoggedInRoutes)
